var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-responsive sortable" },
    [
      _c("filter-input-row", {
        attrs: {
          title: "Payments.PaymentByTypeFilter.Title",
          id: "paymentbytypefilter",
          filterFunction: _vm.filter,
          results: _vm.filteredPayments.length,
          resultsAriaText: "Payments.PaymentByTypeFilter.ResultsAriaText"
        },
        model: {
          value: _vm.filterValue,
          callback: function($$v) {
            _vm.filterValue = $$v
          },
          expression: "filterValue"
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "sr-only",
          attrs: { "aria-live": "assertive", "aria-atomic": "true" }
        },
        [_vm._v("\n    " + _vm._s(_vm.srSortedBy) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table tablerow payments-table sortable",
          attrs: { "aria-label": _vm.$t("Payments.PaymentByType") }
        },
        [
          _c("caption", [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("Payments.PaymentByType")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "pull-right sort-instructions" }, [
              _vm._v(_vm._s(_vm.$t("Sort.Instructions")))
            ])
          ]),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c(
                "th",
                {
                  staticClass: "w-10",
                  attrs: {
                    "aria-sort": _vm.ariaSortValue(
                      "target",
                      _vm.sortedBy,
                      _vm.sortedAsc
                    )
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-link btn-sort",
                      on: {
                        click: function($event) {
                          _vm.displayPayments = _vm.sort(
                            "target",
                            _vm.filteredPayments
                          )
                        }
                      }
                    },
                    [
                      _c("sortable-header-button-content", {
                        attrs: {
                          title: "AidTargetNumber",
                          sortedBy: _vm.sortedBy,
                          sortProperty: "target",
                          sortedAsc: _vm.sortedAsc
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-30",
                  attrs: {
                    "aria-sort": _vm.ariaSortValue(
                      "purpose",
                      _vm.sortedBy,
                      _vm.sortedAsc
                    )
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-link btn-sort",
                      on: {
                        click: function($event) {
                          _vm.displayPayments = _vm.sort(
                            "purpose",
                            _vm.filteredPayments
                          )
                        }
                      }
                    },
                    [
                      _c("sortable-header-button-content", {
                        attrs: {
                          title: "Purpose",
                          sortedBy: _vm.sortedBy,
                          sortProperty: "purpose",
                          sortedAsc: _vm.sortedAsc
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "w-10",
                  attrs: {
                    "aria-sort": _vm.ariaSortValue(
                      "method",
                      _vm.sortedBy,
                      _vm.sortedAsc
                    )
                  }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-link btn-sort",
                      on: {
                        click: function($event) {
                          _vm.displayPayments = _vm.sort(
                            "method",
                            _vm.filteredPayments
                          )
                        }
                      }
                    },
                    [
                      _c("sortable-header-button-content", {
                        attrs: {
                          title: "Payments.PaymentMethod",
                          sortedBy: _vm.sortedBy,
                          sortProperty: "method",
                          sortedAsc: _vm.sortedAsc
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("th", { staticClass: "w-20" }, [
                _c("span", { staticClass: "unsortable" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("Payments.PaymentAction")) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-30" }, [
                _c("span", { staticClass: "unsortable" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("Payments.PaymentDescription")) +
                      "\n          "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.displayPayments, function(payment, index) {
              return _c(
                "tr",
                { key: payment.aidTargetNumber + _vm.paymentKey },
                [
                  payment.aidTargetNumber
                    ? _c("td", [
                        _c("span", [_vm._v(_vm._s(payment.aidTargetNumber))])
                      ])
                    : _c("td", [_c("span", [_vm._v("-")])]),
                  _vm._v(" "),
                  payment.purpose
                    ? _c("td", { staticClass: "normal" }, [
                        _c(
                          "span",
                          {
                            attrs: {
                              title:
                                payment.purpose.length > 100
                                  ? payment.purpose
                                  : ""
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("truncate")(payment.purpose, 100))
                            )
                          ]
                        )
                      ])
                    : _c("td", [_c("span", [_vm._v("-")])]),
                  _vm._v(" "),
                  _vm.paymentMethod(payment)
                    ? _c("td", [
                        _c("span", [_vm._v(_vm._s(_vm.paymentMethod(payment)))])
                      ])
                    : _c("td", [_c("span", [_vm._v("-")])]),
                  _vm._v(" "),
                  _c("td", { staticClass: "normal centered" }, [
                    _vm.showERPROption(payment)
                      ? _c("span", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.createAndOpenERPR(payment)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Payments.CreateERPR")))]
                          )
                        ])
                      : _c("span", [
                          _vm._v(_vm._s(_vm.$t("Payments.NoFunctionAvailable")))
                        ])
                  ]),
                  _vm._v(" "),
                  _vm.showERPRExistsAlready(payment) ||
                  _vm.showERPRStarted(payment) ||
                  _vm.showInsufficientFundsForAid(payment) ||
                  _vm.showInvestmentBudgetaryEstimateStarted(payment) ||
                  _vm.showInvestmentFinalReportStarted(payment)
                    ? _c("td", { staticClass: "normal" }, [
                        _vm.showERPRExistsAlready(payment)
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Payments.PaymentDescriptions.ERPRExistsAlready"
                                  )
                                )
                              ),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showERPRStarted(payment)
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Payments.PaymentDescriptions.ERPRStarted"
                                  )
                                )
                              ),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showInsufficientFundsForAid(payment)
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Payments.PaymentDescriptions.InsufficientFundsForAid"
                                  )
                                )
                              ),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showInvestmentBudgetaryEstimateStarted(payment)
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Payments.PaymentDescriptions.InvestmentBudgetaryEstimateStarted"
                                  )
                                )
                              ),
                              _c("br")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showInvestmentFinalReportStarted(payment)
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Payments.PaymentDescriptions.InvestmentFinalReportStarted"
                                  )
                                )
                              ),
                              _c("br")
                            ])
                          : _vm._e()
                      ])
                    : _c("td", { staticClass: "centered" }, [
                        _c("span", [_vm._v("-")])
                      ])
                ]
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }